import type { LocationRewrite } from '@tanstack/react-router'

const standalonePaths = [
  '/resources',
  '/verify-email',
  '/confirm-email-change',
  '/oauth',
] as const

const isStandalonePath = (pathname: string) =>
  standalonePaths.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  )

/** English is the only live language; keep it internally for typed routes. */
export const gtmUrlRewrite: LocationRewrite = {
  input: ({ url }) => {
    if (
      url.pathname === '/' ||
      url.pathname === '/en' ||
      url.pathname.startsWith('/en/') ||
      url.pathname === '/ru' ||
      url.pathname.startsWith('/ru/') ||
      isStandalonePath(url.pathname)
    ) {
      return url
    }
    url.pathname = `/en${url.pathname}`
    return url
  },
  output: ({ url }) => {
    if (url.pathname === '/en' || url.pathname === '/en/') {
      url.pathname = '/'
    } else if (url.pathname.startsWith('/en/')) {
      url.pathname = url.pathname.slice('/en'.length)
    }
    return url
  },
}
